import axios from 'axios'

export const apiBaseURL = import.meta.env.VITE_APP_API_BASE_URL ?? ''

export const api = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// Unauthenticated, token-based requests (e.g. headless PDF export) — no cookies,
// no CSRF/workspace headers, no 401 redirect.
export const printApi = axios.create({
  baseURL: apiBaseURL,
  headers: {
    Accept: 'application/json',
  },
})
